export default {
  apiKey: "AIzaSyBpsYcJs5xlG7WdWgIflvJPcFSzC3u0wfM",
  authDomain: "gms-dnacloud-eu-p.firebaseapp.com",
  databaseURL: "https://gms-dnacloud-eu-p-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "gms-dnacloud-eu-p",
  storageBucket: "gms-dnacloud-eu-p.appspot.com",
  messagingSenderId: "51279036832",
  appId: "1:51279036832:web:62d9a132bd068b5cdae4c5",
};